import tw from 'twin.macro'
import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

import HubspotForm from '@/components/ui/hubspot-form'
import BwiClose from '@/icons/bwi/close.svg'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocale } from '@plugins/bw-i18next'
import { useLocation } from '@reach/router'

export default function PageSuggestions(): JSX.Element {
  const { currentContentfulCode } = useLocale()
  const { pathname } = useLocation()
  const form = useStaticQuery(graphql`
    query PageSuggestions {
      allContentfulComponentHubSpotForm(filter: { formId: { eq: "525051e7-508c-4dd2-9115-62be2d3e6f73" } }) {
        nodes {
          ...HubSpotForm
        }
      }
    }
  `).allContentfulComponentHubSpotForm.nodes.find((node) => node.node_locale === currentContentfulCode)

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      const frm = document.getElementById('help-page-suggestions') as HTMLFormElement
      frm.scrollIntoView({ behavior: 'smooth' })
    }
    // tell hubspot which page the form is on
    document.querySelectorAll('.hs_form_path')?.forEach((el) => {
      el.querySelector('input[type="hidden"]')?.setAttribute('value', pathname)
    })
  }, [isOpen])

  return (
    <div tw="rounded-4xl p-4 bg-gray-100">
      <div tw="w-full flex">
        <button
          type="button"
          tw="bg-white text-primaryBlue rounded self-end ml-auto h-auto py-2 whitespace-normal hover:bg-gray-200 transition-colors"
          css={[isOpen ? tw`w-auto` : tw`w-full`]}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <BwiClose tw="h-5 w-5 mx-2 my-0" /> : form?.headline}
        </button>
      </div>
      <div id="help-page-suggestions" css={isOpen ? tw`[form>button]:block` : tw`[form>button]:hidden`}>
        <motion.div
          tw="text-sm overflow-hidden px-1"
          animate={{ height: isOpen ? 'auto' : 0, opacity: isOpen ? 1 : 0 }}
        >
          <HubspotForm {...form} />
        </motion.div>
      </div>
    </div>
  )
}
